import QueryService from '@/services/query'
import { VUE_APP_ROOT_API } from '@/helpers/env'

export default {
  getMyEntrepreneurs: async function(id) {
    const response = await QueryService.get(`${VUE_APP_ROOT_API}/entrepreneurapi/getmyentrepreneurs`)
    return await response.json()
  },
  getUserEntrepreneursByBusinessId: async function(id) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/entrepreneurapi/getuserentrepreneursbybusinessid`, JSON.stringify({ id }))
    return await response.json()
  },
  getEntrepreneursByIds: async function(ids) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/entrepreneurapi/getentrepreneursbyids`, JSON.stringify({ ids }))
    return await response.json()
  },
  createEntrepreneur: async function(name, birthdate, gender) {
    let request = { name, gender }

    if (birthdate !== null) {
      request.birthdate = birthdate
    }

    const response = await QueryService.post(`${VUE_APP_ROOT_API}/entrepreneurapi/createentrepreneur`, JSON.stringify(request))
    return await response.json()
  },
  createEntrepreneurFromBusiness: async function(businessId, name, birthdate, gender) {
    let request = { businessId, name, gender }

    if (birthdate !== null) {
      request.birthdate = birthdate
    }

    const response = await QueryService.post(`${VUE_APP_ROOT_API}/entrepreneurapi/createentrepreneurfrombusiness`, JSON.stringify(request))
    return await response.json()
  },
  updateEntrepreneur: async function(request) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/entrepreneurapi/updateentrepreneur`, JSON.stringify(request))
    return await response.json()
  },
  deleteEntrepreneur: async function(entrepreneurId) {
    let request = { entrepreneurId }
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/entrepreneurapi/deleteentrepreneur`, JSON.stringify(request))
    if (response.status === 406) {
      throw new Error('Entrepreneur is still active in a business')
    }
    return await response.json()
  }
}
